import {safeBackOfficeReturn} from '../../pos-shared/back-office-link';
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

function AuthLoadingFallback() {
  return (
    <div className="authShell">
      <div className="authCard authStatusCard">
        Loading...
      </div>
    </div>
  );
}

export default function RequireAuth({ children }: { children: ReactNode }) {
  const location=useLocation(),posBackOfficeReturn=safeBackOfficeReturn(location.pathname+location.search);
  const { authPhase, status, isAuthenticated, isInitializing, isAuthProcessing } = useAuth();

  if (
    isInitializing
    || isAuthProcessing
    || authPhase === "booting"
  ) {
    console.info("[auth-debug]", {
      area: "require-auth",
      event: "wait",
      authPhase,
      status,
      isAuthenticated,
      isInitializing,
      isAuthProcessing,
    });
    return <AuthLoadingFallback />;
  }

  if (authPhase === "unauthenticated" || authPhase === "error" || status === "anon" || !isAuthenticated) {
    console.info("[auth-debug]", {
      area: "require-auth",
      event: "navigate",
      target: "/login",
      authPhase,
      status,
      isAuthenticated,
    });
    return <Navigate to="/login" state={posBackOfficeReturn?{posBackOfficeReturn}:undefined} replace />;
  }
  if (status === "needs-mfa") {
    console.info("[auth-debug]", {
      area: "require-auth",
      event: "navigate",
      target: "/mfa",
      authPhase,
      status,
      isAuthenticated,
    });
    return <Navigate to="/mfa" state={posBackOfficeReturn?{posBackOfficeReturn}:undefined} replace />;
  }
  return <>{children}</>;
}
